export default __webpack_public_path__ + "static/media/ach.a80d6f56.mp3";